
export function FallbackView() {
  return (
    <div className='splash-screen'>
      {/**<img src={toAbsoluteUrl('/media/logos/abei.svg')} alt='ABEI logo' /> */}
      <span>Cargando ...</span>
    </div>
  )
}
